/**
 * @generated SignedSource<<f20d3e2b9e73b9180c9f393c7ebac9b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppClipDefaultCardQuery$variables = {
  id: string;
};
export type AppClipDefaultCardQuery$data = {
  readonly brand: {
    readonly appConfig: {
      readonly " $fragmentSpreads": FragmentRefs<"AppClipDefaultCard_appConfig">;
    };
  };
};
export type AppClipDefaultCardQuery = {
  response: AppClipDefaultCardQuery$data;
  variables: AppClipDefaultCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppClipDefaultCardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AppClipDefaultCard_appConfig"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppClipDefaultCardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appClipHeaderImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appClipSubtitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appClipActionText",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0d681bb7c372e47738c42bf0c6d989a2",
    "id": null,
    "metadata": {},
    "name": "AppClipDefaultCardQuery",
    "operationKind": "query",
    "text": "query AppClipDefaultCardQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    appConfig {\n      ...AppClipDefaultCard_appConfig\n      id\n    }\n    id\n  }\n}\n\nfragment AppClipDefaultCard_appConfig on BrandAppConfigType {\n  id\n  appClipHeaderImageUrl\n  appClipSubtitle\n  appClipActionText\n}\n"
  }
};
})();

(node as any).hash = "6c3d7f489444c44832f08f503d0a480c";

export default node;
